/**
 * Reusable PDP option row picker.
 * All product options (Metal, Size, Stones, etc.) — accordion UI, Shopify selects unchanged.
 */
(function (window, $) {
  if (!$) return;

  var CHEVRON =
    '<svg viewBox="0 0 15 7" aria-hidden="true" focusable="false">' +
    '<polyline fill="none" stroke="#0B233D" stroke-width="0.8" points="1 1 7.5 6 14 1"></polyline>' +
    "</svg>";

  function normalizeLabel(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function optionKey(label) {
    var lower = normalizeLabel(label).toLowerCase();
    if (!lower || lower === "title") return null;
    if (lower === "metal" || lower.indexOf("metal") !== -1) return "metal";
    if (lower === "size" || lower.indexOf("size") !== -1) return "size";
    if (
      lower === "stones" ||
      lower === "stone" ||
      lower === "diamond" ||
      lower === "diamonds" ||
      lower.indexOf("stone") !== -1 ||
      lower.indexOf("diamond") !== -1 ||
      lower.indexOf("carat") !== -1 ||
      lower.indexOf("cts") !== -1
    ) {
      return "stones";
    }
    return null;
  }

  function inferKeyFromSelect($select, name) {
    var key = optionKey(name);
    if (key) return key;

    var joined = "";
    $select.find("option").each(function () {
      joined += " " + ($(this).text() || "").toLowerCase();
    });

    if (joined.indexOf("decide later") !== -1) return "size";
    if (
      joined.indexOf("carat") !== -1 ||
      joined.indexOf("lab-grown") !== -1 ||
      joined.indexOf("diamond") !== -1
    ) {
      return "stones";
    }

    if (name && name.toLowerCase() !== "title") {
      return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    }

    return null;
  }

  function displayLabel(key, original) {
    if (original && normalizeLabel(original)) {
      return normalizeLabel(original);
    }
    if (key === "stones") return "Stones";
    if (key === "size") return "Size";
    if (key === "metal") return "Metal";
    return original || key;
  }

  function allocateOptionKey(baseKey, $stack) {
    if (!baseKey) return null;
    if (!$stack.find('[data-pdp-option-key="' + baseKey + '"]').length) {
      return baseKey;
    }

    var suffix = 2;
    var nextKey = baseKey + "-" + suffix;
    while ($stack.find('[data-pdp-option-key="' + nextKey + '"]').length) {
      suffix += 1;
      nextKey = baseKey + "-" + suffix;
    }
    return nextKey;
  }

  function getSelectOptionIndex($select) {
    var selectId = $select.attr("id") || "";
    var idMatch = selectId.match(/option-(\d+)$/i);
    if (idMatch) return parseInt(idMatch[1], 10);

    var dataOption = ($select.attr("data-option") || "").toLowerCase();
    var dataMatch = dataOption.match(/^option(\d+)$/);
    if (dataMatch) return parseInt(dataMatch[1], 10) - 1;

    return null;
  }

  function isMetalSourceSelect($select) {
    var $metalChoice = $("#metal-choice");
    if (!$metalChoice.length) return false;
    var targetId = $metalChoice.attr("data-target");
    return !!(targetId && $select.attr("id") === targetId);
  }

  function hideNativeSelect($select) {
    var $wrapper = $select.closest(".selector-wrapper");
    if ($wrapper.length) {
      $wrapper.addClass("pdp-option-picker-source-hidden");
    } else {
      $select.addClass("pdp-option-picker-source-hidden");
    }
  }

  function pickerForSelect($stack, $select) {
    var selectId = $select.attr("id");
    if (!selectId) return $();
    return $stack.find('[data-pdp-option-select="' + selectId + '"]');
  }

  function resolveSelectForPicker($picker) {
    var selectId = $picker.attr("data-pdp-option-select");
    var $select = $();
    var selectEl = selectId ? document.getElementById(selectId) : null;

    if (selectEl) {
      $select = $(selectEl);
    }

    if (!$select.length) {
      var optionIndex = parseInt($picker.attr("data-pdp-option-index"), 10);
      if (!isNaN(optionIndex)) {
        $select = $(".product-single")
          .not(".custom-product")
          .first()
          .find("select.single-option-selector")
          .eq(optionIndex);
      }
    }

    if ($select.length && $select.attr("id")) {
      $picker.attr("data-pdp-option-select", $select.attr("id"));
    }

    return $select;
  }

  function triggerSelectChange($select) {
    $select.trigger("change");
    if ($select[0]) {
      $select[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function findOptionInSelect($select, text, optionValue, optionIndex) {
    var $options = $select.find("option");

    if (text) {
      var $byText = $options.filter(function () {
        return normalizeLabel($(this).text()) === text;
      }).first();
      if ($byText.length) return $byText;
    }

    if (optionValue != null && optionValue !== "") {
      var $byValue = $options.filter(function () {
        return this.value === optionValue;
      }).first();
      if ($byValue.length) return $byValue;
    }

    if (!isNaN(optionIndex) && optionIndex >= 0 && optionIndex < $options.length) {
      return $options.eq(optionIndex);
    }

    return $();
  }

  function triggerMetalChoiceByLabel(text) {
    var $metalChoice = $("#metal-choice");
    if (!$metalChoice.length) return false;

    var normalized = normalizeLabel(text);
    if (!normalized) return false;

    var $match = $metalChoice.find("a").filter(function () {
      return normalizeLabel($(this).attr("data-val") || $(this).attr("title") || "") === normalized;
    });

    if (!$match.length) return false;

    $match.first().trigger("click");
    return true;
  }

  function bindSelectSync($picker, $select) {
    $select.off("change.pdpOptionPicker").on("change.pdpOptionPicker", function () {
      syncFromSelect($picker, resolveSelectForPicker($picker));
    });
  }

  function applyPickerOption($picker, $optionBtn) {
    var optionIndex = parseInt($optionBtn.attr("data-option-index"), 10);
    var optionValue = $optionBtn.attr("data-option-value");
    var text = normalizeLabel($optionBtn.attr("data-val") || $optionBtn.text());
    var $select = resolveSelectForPicker($picker);
    var isMetal =
      $picker.attr("data-pdp-option-key") === "metal" ||
      ($select.length && isMetalSourceSelect($select));

    if (isMetal && triggerMetalChoiceByLabel(text)) {
      window.setTimeout(function () {
        var $currentSelect = resolveSelectForPicker($picker);
        if ($currentSelect.length) {
          syncFromSelect($picker, $currentSelect);
          bindSelectSync($picker, $currentSelect);
        }
      }, 0);

      $picker.removeClass("is-open");
      $picker.find(".pdp-option-picker__trigger").attr("aria-expanded", "false");
      return true;
    }

    if (!$select.length) return false;

    $select = resolveSelectForPicker($picker);
    var $targetOption = findOptionInSelect($select, text, optionValue, optionIndex);
    if (!$targetOption.length || $targetOption.is(":disabled")) return false;

    $select.find("option").prop("selected", false);
    $targetOption.prop("selected", true);
    $select[0].selectedIndex = $targetOption[0].index;

    triggerSelectChange($select);
    syncFromSelect($picker, $select);
    bindSelectSync($picker, $select);
    $picker.removeClass("is-open");
    $picker.find(".pdp-option-picker__trigger").attr("aria-expanded", "false");
    return true;
  }

  function closeAll(except) {
    $(".pdp-option-picker.is-open").each(function () {
      if (except && this === except) return;
      $(this).removeClass("is-open");
      $(this).find(".pdp-option-picker__trigger").attr("aria-expanded", "false");
    });
  }

  function getSizeGuideLink() {
    var $link = $("#size-guide-toggle").first();
    if ($link.length) {
      return {
        href: $link.attr("href") || "/pages/size-guide",
        target: $link.attr("target") || "_blank"
      };
    }
    return { href: "/pages/size-guide", target: "_blank" };
  }

  function syncFromSelect($picker, $select) {
    var label = $select.find("option:selected").text() || $select.val() || "";
    label = normalizeLabel(label);
    $picker.find(".pdp-option-picker__value").text(label);
    $picker.find(".pdp-option-picker__option").removeClass("is-selected").each(function () {
      if ($(this).attr("data-val") === label || $(this).attr("data-option-value") === $select.val()) {
        $(this).addClass("is-selected");
      }
    });
  }

  function syncFromMetalLinks($picker, $sourceLinks) {
    var $current = $sourceLinks.filter(".current").first();
    if (!$current.length) $current = $sourceLinks.first();
    var label = $current.attr("data-val") || $current.attr("title") || "";
    $picker.find(".pdp-option-picker__value").text(label);
    $picker.find(".pdp-option-picker__option").removeClass("is-selected").each(function () {
      if ($(this).attr("data-val") === label) {
        $(this).addClass("is-selected");
      }
    });
  }

  function ensureStack($product) {
    var $stack = $product.find(".pdp-option-pickers").first();
    var $titlePrice = $product.find(".mo-title-price").first();

    if (!$stack.length) {
      $stack = $('<div class="pdp-option-pickers"></div>');
      if ($titlePrice.length) {
        $titlePrice.after($stack);
      } else {
        var $variants = $product.find(".product-variants").first();
        if ($variants.length) {
          $variants.prepend($stack);
        } else {
          $product.find("form.AddToCartForm").first().prepend($stack);
        }
      }
      bindStackEvents($stack);
      return $stack;
    }

    if ($titlePrice.length && !$titlePrice.next().is($stack)) {
      $titlePrice.after($stack);
    }

    bindStackEvents($stack);
    return $stack;
  }

  function buildPickerShell(labelText, key) {
    var $picker = $(
      '<div class="pdp-option-picker" data-pdp-option="' +
        labelText +
        '" data-pdp-option-key="' +
        key +
        '">' +
        '<div class="pdp-option-picker__row">' +
          '<span class="pdp-option-picker__label-group">' +
            '<span class="pdp-option-picker__label">' +
            labelText +
            "</span>" +
          "</span>" +
          '<button type="button" class="pdp-option-picker__trigger" aria-expanded="false" aria-haspopup="listbox">' +
            '<span class="pdp-option-picker__meta">' +
              '<span class="pdp-option-picker__value"></span>' +
              '<span class="pdp-option-picker__chevron">' +
              CHEVRON +
              "</span>" +
            "</span>" +
          "</button>" +
        "</div>" +
        '<div class="pdp-option-picker__panel" role="listbox"></div>' +
      "</div>"
    );

    if (key === "size") {
      var guide = getSizeGuideLink();
      $picker.find(".pdp-option-picker__label-group").append(
        $('<a class="pdp-option-picker__guide" rel="noopener">Size Guide</a>')
          .attr("href", guide.href)
          .attr("target", guide.target)
      );
    }

    return $picker;
  }

  function bindStackEvents($stack) {
    $stack = $stack.first();
    if ($stack.data("pdpOptionPickerBound")) return;
    $stack.data("pdpOptionPickerBound", true);

    $stack.on("click.pdpOptionPicker", ".pdp-option-picker__row", function (e) {
      if ($(e.target).closest(".pdp-option-picker__guide").length) return;
      if ($(e.target).closest(".pdp-option-picker__panel, .pdp-option-picker__option").length) return;

      e.preventDefault();
      e.stopPropagation();

      var $picker = $(this).closest(".pdp-option-picker");
      var open = !$picker.hasClass("is-open");
      closeAll(open ? $picker[0] : null);
      $picker.toggleClass("is-open", open);
      $picker.find(".pdp-option-picker__trigger").attr("aria-expanded", open ? "true" : "false");
    });

    $stack.on("click.pdpOptionPicker", ".pdp-option-picker__guide", function (e) {
      e.stopPropagation();
    });

    $stack.on("click.pdpOptionPicker", ".pdp-option-picker__option", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var $picker = $(this).closest(".pdp-option-picker");
      applyPickerOption($picker, $(this));
    });
  }

  function bindOpenClose($picker) {
    /* Row-level delegation handles open/close via bindStackEvents */
  }

  function populatePanelFromSelect($panel, $select) {
    $panel.empty();
    $select.find("option").each(function () {
      var $opt = $(this);
      if ($opt.is(":disabled") && !$opt.is(":selected")) return;
      var val = $opt.attr("value");
      var text = normalizeLabel($opt.text());
      if (!text) return;
      $panel.append(
        $('<button type="button" class="pdp-option-picker__option" role="option"></button>')
          .attr("data-val", text)
          .attr("data-option-value", val)
          .attr("data-option-index", $opt.index())
          .text(text)
      );
    });
    return $panel.children().length > 0;
  }

  function refreshSelectPicker($stack, $select) {
    var selectId = $select.attr("id");
    if (!selectId) return false;

    var $picker = pickerForSelect($stack, $select);
    if (!$picker.length) return false;

    var $panel = $picker.find(".pdp-option-picker__panel");
    if (!populatePanelFromSelect($panel, $select)) return false;

    syncFromSelect($picker, $select);
    bindSelectSync($picker, $select);
    return true;
  }

  function mountMetalPicker($product, $stack) {
    if ($stack.find('[data-pdp-option-key="metal"]').length) return true;

    var $metalChoice = $("#metal-choice");
    if (!$metalChoice.length) return false;

    var $links = $metalChoice.find("a");
    if (!$links.length) return false;

    var $picker = buildPickerShell("Metal", "metal");
    $picker.attr("data-pdp-option-index", 0);
    var $panel = $picker.find(".pdp-option-picker__panel");

    $links.each(function () {
      var $a = $(this);
      var val = $a.attr("data-val") || $a.attr("title") || "";
      $panel.append(
        $('<button type="button" class="pdp-option-picker__option" role="option"></button>')
          .attr("data-val", val)
          .text(val)
      );
    });

    $stack.append($picker);
    bindOpenClose($picker);
    syncFromMetalLinks($picker, $links);

    $panel.on("click", ".pdp-option-picker__option", function (e) {
      e.preventDefault();
      var val = $(this).attr("data-val");
      var $match = $links.filter(function () {
        return $(this).attr("data-val") === val;
      });
      if ($match.length) $match.first().trigger("click");
      syncFromMetalLinks($picker, $links);
      $picker.removeClass("is-open");
      $picker.find(".pdp-option-picker__trigger").attr("aria-expanded", "false");
    });

    $metalChoice.on("click", "a", function () {
      window.setTimeout(function () {
        syncFromMetalLinks($picker, $links);
      }, 0);
    });

    var selectId = $metalChoice.attr("data-target");
    if (selectId) {
      $("#" + selectId).on("change.pdpOptionPicker", function () {
        syncFromMetalLinks($picker, $links);
      });
    }

    return true;
  }

  function mountSelectPicker($product, $stack, $select, key, originalLabel, optionIndex) {
    if (!$select || !$select.length) return false;

    var selectId = $select.attr("id") || "option-select-" + optionIndex;
    if (!$select.attr("id")) {
      $select.attr("id", selectId);
    }

    if (pickerForSelect($stack, $select).length) {
      return refreshSelectPicker($stack, $select);
    }

    var labelText = displayLabel(key, originalLabel || key);
    var $picker = buildPickerShell(labelText, key);
    $picker.attr("data-pdp-option-select", selectId);
    if (typeof optionIndex === "number" && !isNaN(optionIndex)) {
      $picker.attr("data-pdp-option-index", optionIndex);
    }
    var $panel = $picker.find(".pdp-option-picker__panel");

    if (!populatePanelFromSelect($panel, $select)) return false;

    $stack.append($picker);
    hideNativeSelect($select);

    syncFromSelect($picker, $select);

    bindSelectSync($picker, $select);

    return true;
  }

  function resolveOptionName($select, index) {
    var options = window.PdpProductOptions;
    if (options && options.length && options[index]) {
      return normalizeLabel(options[index]);
    }

    var dataOption = ($select.attr("data-option") || "").toLowerCase();
    if (dataOption.indexOf("option") === 0 && options && options.length) {
      var n = parseInt(dataOption.replace("option", ""), 10) - 1;
      if (!isNaN(n) && options[n]) return normalizeLabel(options[n]);
    }

    var fromLabel = normalizeLabel($select.closest(".selector-wrapper").find("label").first().text());
    if (fromLabel) return fromLabel;

    var selectId = $select.attr("id") || "";
    var idMatch = selectId.match(/option-(\d+)/i);
    if (idMatch && options && options[idMatch[1]]) {
      return normalizeLabel(options[idMatch[1]]);
    }

    return "";
  }

  function reorderStack($stack) {
    var $pickers = $stack.children(".pdp-option-picker").get().sort(function (a, b) {
      var indexA = parseInt($(a).attr("data-pdp-option-index"), 10);
      var indexB = parseInt($(b).attr("data-pdp-option-index"), 10);
      if (isNaN(indexA)) indexA = 999;
      if (isNaN(indexB)) indexB = 999;
      return indexA - indexB;
    });

    var changed = false;
    $pickers.forEach(function (picker, i) {
      if ($stack[0].children[i] !== picker) changed = true;
    });
    if (!changed) return;

    // Move nodes in sort order without .empty() — jQuery .empty() strips bound handlers.
    $pickers.forEach(function (picker) {
      $stack[0].appendChild(picker);
    });
  }

  function mountStickyMetalSelector($product) {
    // On mobile, `template-product.css` pins `.size-box-wrapper` to the bottom.
    // We inject a small Metal selector UI inside it.
    var $sizeWrapper = $product.find(".size-box-wrapper").first();
    if (!$sizeWrapper.length) return false;

    var $metalChoice = $product.find("#metal-choice").first();
    if (!$metalChoice.length) return false;

    var $links = $metalChoice.find("a");
    if (!$links.length) return false;

    if ($sizeWrapper.find(".sticky-metal-row").length) return true;

    var CHEVRON_SM =
      '<svg viewBox="0 0 15 7" aria-hidden="true" focusable="false">' +
      '<polyline fill="none" stroke="#0B233D" stroke-width="0.8" points="1 1 7.5 6 14 1"></polyline>' +
      "</svg>";

    // "Made to order..." line is already written into `.out-of-stock-msg` by existing
    // selectCallback logic. We'll move that element into the same row as the Metal dropdown.
    var $stockMsg = $sizeWrapper.find(".out-of-stock-msg").first();

    function getCurrentMetalVal() {
      var $current = $links.filter(".current").first();
      if (!$current.length) $current = $links.first();
      return (
        $current.attr("data-val") ||
        $current.attr("title") ||
        $current.text() ||
        ""
      );
    }

    function updateSelect() {
      var val = normalizeLabel(getCurrentMetalVal());
      if (!val) return;
      $select.val(val);
    }

    // Build select options from the same source used by the real metal picker.
    var seen = {};
    var $select = $('<select class="sticky-metal-select" aria-label="Metal"></select>');
    $links.each(function () {
      var $a = $(this);
      var val = $a.attr("data-val") || $a.attr("title") || $a.text() || "";
      val = normalizeLabel(val);
      if (!val) return;
      if (seen[val]) return;
      seen[val] = true;
      $select.append('<option value="' + val + '">' + val + "</option>");
    });

    var currentVal = getCurrentMetalVal();
    currentVal = normalizeLabel(currentVal);
    if (currentVal) $select.val(currentVal);

    var $row = $(
      '<div class="sticky-metal-row">' +
        '<span class="sticky-metal-row__label">Metal</span>' +
        '<span class="sticky-metal-row__select-wrap">' +
          '<span class="sticky-metal-row__chevron">' + CHEVRON_SM + "</span>" +
        "</span>" +
        '<span class="sticky-metal-row__meta"></span>' +
      "</div>"
    );

    $row.find(".sticky-metal-row__select-wrap").prepend($select);

    var $insertBefore = $sizeWrapper.find("button[type='submit'], button[name='add']").first();
    if ($insertBefore.length) $insertBefore.before($row);
    else $sizeWrapper.prepend($row);

    if ($stockMsg.length) {
      $row.find(".sticky-metal-row__meta").append($stockMsg);
    }

    $select.off("change.pdpStickyMetal").on("change.pdpStickyMetal", function () {
      var val = $(this).val();
      if (!val) return;

      // Trigger the same click handler as the real metal picker.
      var $match = $links.filter(function () {
        return normalizeLabel($(this).attr("data-val") || $(this).attr("title") || $(this).text()) === val;
      });
      if ($match.length) $match.first().trigger("click");

      window.setTimeout(updateSelect, 0);
    });

    // Keep select in sync if metal is changed by any other UI.
    $metalChoice.off("click.pdpStickyMetal").on("click.pdpStickyMetal", "a", function () {
      window.setTimeout(updateSelect, 0);
    });

    updateSelect();
    return true;
  }

  function mountAll() {
    if ($(".pdp-option-picker.is-open").length) {
      window.clearTimeout(window.__pdpOptionPickerMountTimer);
      window.__pdpOptionPickerMountTimer = window.setTimeout(function () {
        window.__pdpOptionPickerMountTimer = null;
        if (!$(".pdp-option-picker.is-open").length) {
          mountAll();
        }
      }, 160);
      return false;
    }

    var $product = $(".product-single").not(".custom-product").first();
    if (!$product.length) return false;

    var $stack = ensureStack($product);

    mountStickyMetalSelector($product);

    var $form = $product.find("form.AddToCartForm").first();
    var $scope = $form.length ? $form : $product;
    var $selects = $scope.find("select.single-option-selector");

    if (!$selects.length) {
      $selects = $product.find("select.single-option-selector");
    }

    $selects.each(function (index) {
      var $select = $(this);

      var optionIndex = getSelectOptionIndex($select);
      if (optionIndex === null) optionIndex = index;

      var name = resolveOptionName($select, optionIndex);
      var baseKey = inferKeyFromSelect($select, name);
      if (!baseKey) {
        baseKey = "option-" + (optionIndex + 1);
      }
      var key = allocateOptionKey(baseKey, $stack);
      mountSelectPicker($product, $stack, $select, key, name, optionIndex);
    });

    reorderStack($stack);

    if ($stack.children().length) {
      $product.addClass("has-pdp-option-picker");
    }

    return $stack.find(".pdp-option-picker").length > 0;
  }

  function watchVariantSelects() {
    if (!window.MutationObserver) return;

    var $product = $(".product-single").not(".custom-product").first();
    var $form = $product.find("form.AddToCartForm").first();
    if (!$form.length) return;
    if ($form.data("pdpOptionPickerObserver")) return;

    var mountTimer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(mountTimer);
      mountTimer = window.setTimeout(mountAll, 120);
    });
    observer.observe($form[0], { childList: true, subtree: true });
    $form.data("pdpOptionPickerObserver", observer);
  }

  function init() {
    var tries = 0;
    function attempt() {
      mountAll();
      tries += 1;
      if (tries < 40) {
        window.setTimeout(attempt, 50);
      } else {
        watchVariantSelects();
      }
    }
    attempt();
  }

  $(document).on("click.pdpOptionPicker", function (e) {
    if ($(e.target).closest(".pdp-option-picker__option").length) return;
    if (!$(e.target).closest(".pdp-option-picker").length) {
      closeAll();
    }
  });

  $(document).ready(init);
  $(document).on("shopify:section:load", init);

  window.PdpOptionPicker = {
    init: init,
    mountAll: mountAll,
    closeAll: closeAll
  };
})(window, window.jQuery);
